import { render, staticRenderFns } from "./PaginaAttivitaBanco.vue?vue&type=template&id=e2e3d03c&"
import script from "./PaginaAttivitaBanco.vue?vue&type=script&lang=js&"
export * from "./PaginaAttivitaBanco.vue?vue&type=script&lang=js&"
import style0 from "./PaginaAttivitaBanco.vue?vue&type=style&index=0&id=e2e3d03c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports